import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import TsrOrderLayout from './layouts/TsrOrderLayout';
import TsrAdminRoute from './auth/TsrAdminRoute';
import TsrAdminLoginPage from './pages/admin/TsrAdminLoginPage';
import TsrAdminHomePage from './pages/admin/TsrAdminHomePage';
import TsrAdminDashboardHome from './pages/admin/TsrAdminDashboardHome';
import TsrAdminCreatePackagePage from './pages/admin/TsrAdminCreatePackagePage';
import TsrAdminCouponsPage from './pages/admin/TsrAdminCouponsPage';
import TsrAdminMenuItemsPage from './pages/admin/TsrAdminMenuItemsPage';
import { isTsrAdminAuthenticated } from './auth/tsrAdminAuth';

function TsrAdminRoutes() {
  return (
    <TsrOrderLayout>
      <Routes>
        <Route
          index
          element={isTsrAdminAuthenticated() ? <Navigate to="/tsr-admin/home" replace /> : <TsrAdminLoginPage />}
        />
        <Route element={<TsrAdminRoute />}>
          <Route element={<TsrAdminHomePage />}>
            <Route path="home" element={<TsrAdminDashboardHome />} />
            <Route path="create-package" element={<TsrAdminCreatePackagePage />} />
            <Route path="menu-items" element={<TsrAdminMenuItemsPage />} />
            <Route path="coupons" element={<TsrAdminCouponsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/tsr-admin" replace />} />
      </Routes>
    </TsrOrderLayout>
  );
}

export default TsrAdminRoutes;
